<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Usage:</span>
      <span class="text-sm">{{ systemInfo.cpu_usage }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Memory Usage:</span>
      <span class="text-sm">{{ systemInfo.memory_usage }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Model:</span>
      <span class="text-sm">{{ systemInfo.device_model }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">MAC Address:</span>
      <span class="text-sm">{{ systemInfo.mac_address }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Serial Number:</span>
      <span class="text-sm">{{ systemInfo.serial_number }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Software Version:</span>
      <span class="text-sm">{{ systemInfo.software_version }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Hardware Version:</span>
      <span class="text-sm">{{ systemInfo.hardware_version }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Temperature:</span>
      <span class="text-sm">{{ systemInfo.temperature }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Running Time:</span>
      <span class="text-sm">{{ systemInfo.running_time }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">System Name:</span>
      <span class="text-sm">{{ systemInfo.system_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VsolSystemInfo',
  props: {
    systemInfo: {
      type: Object,
      required: true
    }
  }
}
</script>